<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GSE81L/images/9781455565429_cover_epub.jpg?1732137007855" alt="This image is the cover for the book My Perfect Mistake, Over the Top"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Perfect Mistake, Over the Top
      </h1>
      <p class="bookDescription body article font2">
        <p>What happens in Aspen is definitely not staying in Aspen . . .<br/> A girls' trip to Aspen was exactly what Shay needed to forget about her toxic ex-boyfriend. She's got her girls, pristine slopes for skiing, and hot guys everywhere. Of course, her epic self-rediscovery goes completely to hell when a wild (and deliciously hot) skier knocks Shay on her ass . . . and war is declared. <br/><br/> Kolton doesn't know what it is about Shay that makes him lose it. Not just his cool---although she does have an unholy gift for that---but his restraint. When anger gives way to explosive chemistry, they're both shaken with the intensity of it. But somewhere between lust and hate, Kolton and Shay realize they could have something real. . . if they don't kill each other first.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Siskind
      </h2>
      
      <p class="authorDescription body article">A small-town girl at heart, <B>Kelly Siskind</B> moved from the city to open a cheese shop with her husband in Northern Ontario. When she's not neck deep in cheese or out hiking, you can find her, notepad in hand, scribbling down one of the many plot bunnies bouncing around in her head.<br><br> She laughs at her own jokes and has been known to eat her feelings -- Gummy Bears heal all. She's also an incurable romantic, devouring romance novels into the wee hours of the morning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bb76eba